import type { ValueFormatterParams } from "ag-grid-community";

export const formatNumber = (value: unknown, fractionDigits: number = 0): string => {
	const num = typeof value === 'number' ? value : Number(value ?? 0);
	if (!isFinite(num)) return '';
	return num.toLocaleString(undefined, {
		minimumFractionDigits: fractionDigits,
		maximumFractionDigits: fractionDigits,
	});
};

// 소수점 자리수 고정
export const formatNumberToFixed = (value: unknown, fractionDigits: number): string => {
	if (value == null || value === '') return '';
	const num = Number(value);
	if (!isFinite(num)) return '';
	return num.toFixed(fractionDigits);
};

export const createGridNumberFormatter = (fractionDigits: number) =>
	(params: ValueFormatterParams): string => formatNumberToFixed(params.value, fractionDigits);

/** AG Grid valueFormatter — 소수점 2자리 (온도·습도 등) */
export const formatGridNumber2 = createGridNumberFormatter(2);

/** AG Grid valueFormatter — 소수점 3자리 (용수사용량 지침 · 전력량 등) */
export const formatGridNumber3 = createGridNumberFormatter(3);

/**
 * 그리드의 숫자를 천 단위 구분이 있는 정수로 표시한다.
 * @param params 현재 셀 값
 * @returns 빈 값 또는 정수 표시 문자열
 */
export const formatGridInteger = (params: { value: number | string | null | undefined }): string => {
	if (params.value == null || params.value === '') return '';
	return Number(params.value).toLocaleString('ko-KR', {
		minimumFractionDigits: 0, maximumFractionDigits: 0,
	});
};

/**
 * 그리드의 숫자를 천 단위 구분이 있는 소수 첫째 자리로 표시한다.
 * @param params 현재 셀 값
 * @returns 빈 값 또는 소수 첫째 자리 표시 문자열
 */
export const formatGridDecimal1 = (params: { value: number | string | null | undefined }): string => {
	if (params.value == null || params.value === '') return '';
	return Number(params.value).toLocaleString('ko-KR', {
		minimumFractionDigits: 1, maximumFractionDigits: 1,
	});
};
